import axiosApiInstance from "../middleware/axios";
import {
    BATCH_OWNER_UPDATE,
    DELETE_ONETIME_ADDRESS,
    SEARCH_USER_GET,
    SINGLE_OWNER_UPDATE,
    USER_NAME_AUTOCOMPLETE_GET,
    USER_ONETIME_ADDRESSES,
} from "./urls";

export const getApiUserAutocomplete = async (searchTerm) => {
    const encodedSearchTerm = window.btoa(searchTerm);
    return await axiosApiInstance.get(
        USER_NAME_AUTOCOMPLETE_GET(encodedSearchTerm)
    );
};

/**
 * Sends patch request to batch req owner change API.
 * @param {Boolean} isPreflight - flag denoting if API should
 * be called in `prelight mode`, a mode that does provides
 * metadata about the request that would be sent if `isPreflight`
 * was set to false
 * @param {{from_owner: string, to_owner: string, from_date: string, to_date: string}} body - patch body
 * @returns
 */
export const patchBatchReqOwnerUpdate = async (isPreflight, body) => {
    return await axiosApiInstance.patch(BATCH_OWNER_UPDATE(isPreflight), body);
};

export const patchSingleReqOwnerUpdate = async (body) => {
    return await axiosApiInstance.patch(SINGLE_OWNER_UPDATE(), body);
};

export const getUserAddresses = async (offset, n) => {
    const params = offset && n ? { params: { offset: offset, n: n } } : {};
    return await axiosApiInstance.get(USER_ONETIME_ADDRESSES, {
        parameters: params,
    });
};

export const deleteUserAddress = async (addressId) => {
    return await axiosApiInstance.delete(
        `${DELETE_ONETIME_ADDRESS}/${addressId}`
    );
};

export const searchUser = async (queryParams) => {
    const query = {};
    ["user_name", "person_id"].forEach((key) => {
        if (queryParams[key]) query[key] = queryParams[key];
    });

    return await axiosApiInstance.get(SEARCH_USER_GET(queryParams));
};
